module.exports = __webpack_public_path__ + "static/img/img-card-big-bike.b28ada6.png";